import { render, staticRenderFns } from "./Gc111.vue?vue&type=template&id=4566fac3&scoped=true"
import script from "./Gc111.vue?vue&type=script&lang=js"
export * from "./Gc111.vue?vue&type=script&lang=js"
import style0 from "./Gc111.vue?vue&type=style&index=0&id=4566fac3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4566fac3",
  null
  
)

export default component.exports